/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlAvailableOtherIntegrations = {
    GoogleAlertCenter: 'google-alert-center',
    MicrosoftEntra: 'microsoft-entra'
} as const;
export type ControlAvailableOtherIntegrations = typeof ControlAvailableOtherIntegrations[keyof typeof ControlAvailableOtherIntegrations];


export function ControlAvailableOtherIntegrationsFromJSON(json: any): ControlAvailableOtherIntegrations {
    return ControlAvailableOtherIntegrationsFromJSONTyped(json, false);
}

export function ControlAvailableOtherIntegrationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAvailableOtherIntegrations {
    return json as ControlAvailableOtherIntegrations;
}

export function ControlAvailableOtherIntegrationsToJSON(value?: ControlAvailableOtherIntegrations | null): any {
    return value as any;
}

